<template>
  <div class="h-screen overflow-y-hidden">
    <MyMenu style="height: 3rem;" />
    <div style="height: calc(100vh - 3rem);">
      <slot />
    </div>
  </div>
</template>